// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__CvyYR","content":"styles_content___878D","link":"styles_link__m5xw3","text":"styles_text__Lhxag","title":"styles_title__vc7Ev"};